import {StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import React, {useEffect, useState} from 'react';
import useGetCompletedPuzzlesCoachApi from '@/Hooks/ClassroomInfoApi/useGetCompletedPuzzlesCoachApi';
import useGetCompletedPuzzlesApi from '@/Hooks/ClassroomInfoApi/useGetCompletedPuzzlesApi';
import useGetStudentsListApi from '@/Hooks/ClassroomInfoApi/useGetStudentsListApi';
import ChessBoardCard from '../../utils/ChessboardCard/ChessBoardCard';
import {ScrollView} from 'react-native-gesture-handler';
import Loader from '@/Atoms/CCLoader';
import ChessBoardCoachCard from '../../utils/ChessboardCard/ChessBoardCoachCard';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes, vs} from '@/Utils/Dimensions';
import CCPackageTable from '@/Atoms/CCPackageTable';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import useClassroomStore from '../../store/timerStore';

interface CompletedPuzzleProps {
  meetingRole: string;
  meetingId: string;
  occurenceId: string;
  activeTabLeft: string;
  source: string;
}

const tabStudentsListHeaders = [
  'StudentName',
  'Solved',
  'Solved with Hint',
  'Not Solved',
  'Not Attempted',
  'Avg. Attempt',
  'Avg. Solve Time(s)',
];

const CompletedPuzzle: React.FC<CompletedPuzzleProps> = ({
  meetingRole,
  meetingId,
  occurenceId,
  activeTabLeft,
  source,
}) => {
  const [role, setRole] = useState<number>(meetingRole === 'student' ? 0 : 1);
  const [completedPuzzles, setCompletedPuzzles] = useState([]);
  const [completedCoachPuzzles, setCompletedCoachPuzzles] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [totalPuzzles, setTotalPuzzles] = useState();
  const [studentsData, setStudentsData] = useState([]);
  const [refreshCoachView, setRefreshCoachView] = useState<number>(0);
  const setDurations = useClassroomStore(state => state.setDurations);

  const handleOnSuccessGetCompletedPuzzles = data => {
    console.log('handleOnSuccessGetCompletedPuzzles data', data);
    if (data?.countdown_timer) {
      setDurations({
        duration: data?.countdown_timer?.start_delay,
        timerDuration: data?.countdown_timer?.timer_duration,
      });
    }
    setCompletedPuzzles(data?.puzzles || []);
    setIsLoading(false);
  };

  const handleOnSuccessGetCompletedPuzzlesCoach = data => {
    console.log('handleOnSuccessGetCompletedPuzzlesCoach data', data);
    setDurations({
      duration: data?.countdown_timer?.start_delay,
      timerDuration: data?.countdown_timer?.timer_duration,
    });
    setCompletedCoachPuzzles(data?.puzzles || []);
    setTotalPuzzles(data?.total_puzzles);
    setIsLoading(false);
  };

  const handleOnSuccessGetStudentsList = data => {
    console.log('handleOnSuccessGetStudentsList data', data);

    const formattedData = data?.students?.map(student => {
      const studentName = student.name;
      const solved = student.solved_count;
      const solvedWithHint = student.solved_with_hint_count;
      const notSolved = student.not_solved_count;
      const notAttempted = student.not_attempted_count;
      const avgAttemptCount = student.avg_attempts;
      const avgSolveTime = student.avg_time_taken;

      let itemValues: any[] = [];
      // Student Name
      itemValues.push({
        name: (
          <Box style={{padding: vs(12), width: '100%', height: '100%'}}>
            <Box
              type="row-flex-start"
              style={{margin: 'auto', width: '100%', flexWrap: 'wrap'}}>
              <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
                {studentName}
              </CCText>
            </Box>
          </Box>
        ),
        type: 'text',
      });
      // Solved
      itemValues.push({
        name: (
          <Box style={{padding: vs(12), width: '100%', height: '100%'}}>
            <CCText fontSize={FontSizes[13]}>{solved}</CCText>
          </Box>
        ),
        type: 'text',
      });
      // Solved with Hint
      itemValues.push({
        name: (
          <Box style={{padding: vs(12), width: '100%', height: '100%'}}>
            <CCText fontSize={FontSizes[13]}>{solvedWithHint}</CCText>
          </Box>
        ),
        type: 'text',
      });
      // Not Solved
      itemValues.push({
        name: (
          <Box style={{padding: vs(12), width: '100%', height: '100%'}}>
            <CCText fontSize={FontSizes[13]}>{notSolved}</CCText>
          </Box>
        ),
        type: 'text',
      });
      // Not Attempted
      itemValues.push({
        name: (
          <Box style={{padding: vs(12), width: '100%', height: '100%'}}>
            <CCText fontSize={FontSizes[13]}>{notAttempted}</CCText>
          </Box>
        ),
        type: 'text',
      });
      // Avg Attempts
      itemValues.push({
        name: (
          <Box style={{padding: vs(12), width: '100%', height: '100%'}}>
            <CCText fontSize={FontSizes[13]}>{avgAttemptCount}</CCText>
          </Box>
        ),
        type: 'text',
      });
      // Avg Solve Time
      itemValues.push({
        name: (
          <Box style={{padding: vs(12), width: '100%', height: '100%'}}>
            <CCText fontSize={FontSizes[13]}>{avgSolveTime || 'NA'}</CCText>
          </Box>
        ),
        type: 'text',
      });
      return itemValues;
    });
    setStudentsData(formattedData || []);
  };

  const {mutate: getCompletedPuzzles} = useGetCompletedPuzzlesApi(
    handleOnSuccessGetCompletedPuzzles,
  );

  const {mutate: getCompletedPuzzlesCoach} = useGetCompletedPuzzlesCoachApi(
    handleOnSuccessGetCompletedPuzzlesCoach,
  );

  const {mutate: getStudentListForCoach} = useGetStudentsListApi(
    handleOnSuccessGetStudentsList,
  );

  useEffect(() => {
    console.log('role', role);
    if (role === 0) getCompletedPuzzles({meetingId, occurenceId});
  }, [activeTabLeft]);

  useEffect(() => {
    if (role === 1) {
      console.log('Its triggered');
      setIsLoading(true);
      getCompletedPuzzlesCoach({meetingId, occurenceId});
      getStudentListForCoach({meetingId, occurenceId});
    }
  }, [meetingId, occurenceId, refreshCoachView]);

  return (
    <>
      <Loader loading={isLoading} bgWhite={true} />
      {role === 1 && (
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <View style={{flexDirection: 'row'}}>
            <TouchableOpacity onPress={() => setTabIndex(0)}>
              <Box
                style={[
                  styles.boxTitle,
                  tabIndex === 0 && {backgroundColor: CCColors.Primary.Brown},
                ]}>
                <CCText
                  style={[
                    styles.boxTitleText,
                    tabIndex === 0 && {
                      color: CCColors.White,
                      fontWeight: 'bold',
                    },
                  ]}>
                  Puzzles - {totalPuzzles}
                </CCText>
              </Box>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => setTabIndex(1)}>
              <Box
                style={[
                  styles.boxTitle,
                  tabIndex === 1 && {backgroundColor: CCColors.Primary.Brown},
                ]}>
                <CCText
                  style={[
                    styles.boxTitleText,
                    tabIndex === 1 && {
                      color: CCColors.White,
                      fontWeight: 'bold',
                    },
                  ]}>
                  All Students
                </CCText>
              </Box>
            </TouchableOpacity>
          </View>
          <TouchableOpacity
            onPress={() => setRefreshCoachView(prev => prev + 1)}>
            <Icon name="reload" color={CCColors.Primary.Brown} size={22} />
          </TouchableOpacity>
        </View>
      )}
      <ScrollView
        style={{height: '40%', minHeight: 500}} //to verify
        showsVerticalScrollIndicator={false}>
        {role === 0 && (
          <View
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}>
            {completedPuzzles.length === 0 ? (
              <View style={styles.emptyState}>
                <CCText fontSize={FontSizes[18]} style={styles.emptyTitle}>
                  No Puzzles Completed Yet
                </CCText>
                <CCText
                  fontSize={FontSizes[14]}
                  style={styles.emptyDescription}>
                  Completed Puzzles will appear once coach publishes a puzzle
                </CCText>
              </View>
            ) : (
              (source === 'recording'
                ? [...completedPuzzles].reverse()
                : completedPuzzles
              ).map((puzzle, index) => (
                <ChessBoardCard
                  key={index}
                  id={index}
                  fen={puzzle?.fen}
                  puzzleName={puzzle?.puzzle_name}
                  orientation={puzzle?.orientation}
                  score={puzzle?.score}
                  solveTime={puzzle?.solve_time}
                  attemptCount={puzzle?.attempt_count}
                  solved={puzzle?.solved}
                  puzzleTime={puzzle?.puzzle_time}
                />
              ))
            )}
          </View>
        )}
        {role === 1 && tabIndex === 0 && (
          <View style={{flexDirection: 'row', flexWrap: 'wrap'}}>
            {/* <Loader loading={isLoading} bgWhite={true} /> */}
            {completedCoachPuzzles.map((puzzle, index) => (
              <ChessBoardCoachCard
                key={index}
                id={index}
                fen={puzzle?.fen}
                puzzleName={puzzle?.puzzle_name}
                orientation={puzzle?.orientation}
                avgAttempts={puzzle?.avg_attempts}
                avgSolveTime={puzzle?.avg_solve_time_in_seconds}
                puzzleTime={puzzle?.puzzle_time}
                // solvedPercentage={48}
                // notAttemptedPercentage={12}
                // solvedWithHintPercentage={25}
                // notSolvedPercentage={15}
                solvedPercentage={puzzle?.solved_percentage}
                notAttemptedPercentage={puzzle?.not_attempted_percentage}
                solvedWithHintPercentage={puzzle?.solved_with_hint_percentage}
                notSolvedPercentage={puzzle?.not_solved_percentage}
              />
            ))}
          </View>
        )}
        {role === 1 && tabIndex === 1 && (
          <CCPackageTable
            headers={tabStudentsListHeaders}
            flexArr={[2, 1, 1, 1, 1, 1, 1]}
            tableData={studentsData}
            isMargin={false}
          />
        )}
      </ScrollView>
    </>
  );
};

export default CompletedPuzzle;

const styles = StyleSheet.create({
  boxTitle: {
    borderWidth: 0.5,
    borderRadius: 5,
    // width: '30%',
    minWidth: 100,
    maxWidth: 250,
    padding: 4,
    margin: 8,
    alignItems: 'center',
    backgroundColor: CCColors.White,
  },
  boxTitleText: {
    color: CCColors.TextColor.Primary,
    fontSize: FontSizes[14],
  },
  emptyState: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 40,
    paddingHorizontal: 20,
  },
  emptyTitle: {
    fontWeight: 'bold',
    marginBottom: 8,
    textAlign: 'center',
    color: CCColors?.TextColor?.Primary || '#000000',
  },
  emptyDescription: {
    textAlign: 'center',
    color: CCColors?.TextColor?.Secondary || '#666666',
    lineHeight: 20,
  },
});
